import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import { Region } from "@hubcapp/types";

import regionQuery from "../graph-ql/region.graphql";

const useQueryRegion = (
  id?: string,
  onCompleted?: QueryHookOptions["onCompleted"],
) =>
  useQuery<{ region: Region }>(regionQuery, {
    variables: {
      id,
    },
    skip: !id,
    fetchPolicy: "cache-first",
    onCompleted,
  });

export default useQueryRegion;
